import DateTime from '@dealroadshow/uikit-date-time';
import { MONTH_DAY_YEAR_FORMAT } from '@dealroadshow/uikit-date-time/dateFormats';
import type { IFilterTag } from '../types';
import type { IDateConfig } from '../configs';
import { UTC_TIME_ZONE } from '@dealroadshow/uikit-date-time/vo/timeZoneConstants';

const formatDate = (value: string): string => new DateTime(value, { timeZone: UTC_TIME_ZONE })
  .format(MONTH_DAY_YEAR_FORMAT);

const getDateTags = <TFilters, TBoundaries>(
  configs: IDateConfig<TFilters, TBoundaries>[],
  filters: TFilters,
  boundaries: TBoundaries | null,
): IFilterTag[] =>
  configs.flatMap(({ key, fromKey, toKey, boundaryKey, label }) => {
    const from = filters[fromKey] as string | null;
    const to = filters[toKey] as string | null;
    if (!from && !to) return [];

    const bounds = boundaries?.[boundaryKey] as { from: string, to: string } | null;
    const displayFrom = from ?? bounds?.from ?? null;
    const displayTo = to ?? bounds?.to ?? null;
    const parts = [displayFrom && formatDate(displayFrom), displayTo && formatDate(displayTo)]
      .filter(Boolean)
      .join(' – ');

    return [{ key, label: `${ label }: ${ parts }`, isExclude: false, removable: true }];
  });

export default getDateTags;
